import api from '@pray/shared/utils/api';

export type ValidateDomainResponse = {
  id: number;
  valid: boolean;
  validation_results: Record<string, { valid: boolean; reason: string | null }>;
};

export type ValidateEmailHealthDomainParams = {
  domainId: number;
};

export async function validateEmailHealthDomain({
  domainId,
}: ValidateEmailHealthDomainParams): Promise<ValidateDomainResponse> {
  const url = `/web/studio/system-check/email-health/domains/${domainId}/validate`;
  const response = await api.executePostRequest<ValidateDomainResponse>(url);

  return response.data;
}
